<div class="foxit-pdf-viewer-app">
    <app-foxitpdfviewer class="foxit-pdf-viewer-container"></app-foxitpdfviewer>
</div>
